export default (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="100%" height="100%">
    <rect width="64" height="64" rx="8" fill="#1b1b38" />
    <text
      x="32"
      y="40"
      fontFamily="Arial, sans-serif"
      fontSize="18"
      fontWeight="bold"
      fill="#ff5a5f"
      textAnchor="middle"
    >
      NOSTO
    </text>
  </svg>
);
